export type ViewState = 
  | 'home' 
  | 'booking' 
  | 'services' 
  | 'about' 
  | 'gallery'
  | 'blog'
  | 'blog-post'
  | 'hair-salon'
  | 'nail-salon'
  | 'skin-treatments'
  | 'lash-brow'
  | 'bridal'
  | 'location-al-rawdah'
  | 'location-adnec'
  | 'location-aloft';


export const CATEGORIES = [
  'Hair Services',
  'Haircut',
  'Hair Coloring',
  'Hair Treatment',
  'Nails',
  'Lashes',
  'Brows',
  'Facials & Skincare',
  'Wax Services',
  'Aesthetics',
  'Bridal',
  'Semi Permanent Makeup',
] as const;

export type Category = typeof CATEGORIES[number];

export interface Service {
  id: string;
  category: Category;
  name: string;
  description: string;
  price: string;
  duration?: string;
}

export const SERVICES: Service[] = [
  { id: 'hs1', category: 'Hair Services', name: 'Wavy Blow Dry', description: 'Professional wash and wavy styling for polished event-ready hair in Abu Dhabi.', price: 'from 150 AED', duration: '1 hr' },
  { id: 'hc1', category: 'Haircut', name: 'Tailored Hair Cut', description: 'Precision haircut tailored to your face shape, lifestyle, and preferred finish.', price: '150 AED', duration: '1 hr' },
  { id: 'hcol1', category: 'Hair Coloring', name: 'Roots Colour', description: 'Color touch-up for regrowth to keep your hair color seamless and fresh.', price: 'from 200 AED', duration: '1.5 hrs' },
  { id: 'hcol2', category: 'Hair Coloring', name: 'Balayage & Highlights', description: 'Custom hand-painted balayage or foil highlights for dimension and brightness.', price: 'from 450 AED', duration: '3 hrs' },
  { id: 'hcol3', category: 'Hair Coloring', name: 'Full Hair Coloring', description: 'Single-process or full color transformation using premium salon color systems.', price: 'from 350 AED', duration: '2.5 hrs' },
  { id: 'ht1', category: 'Hair Treatment', name: 'Keratin Treatment', description: 'Smoothing keratin treatment to reduce frizz and improve manageability in the UAE climate.', price: 'from 600 AED', duration: '3 hrs' },
  { id: 'ht2', category: 'Hair Treatment', name: 'Hair Botox Treatment', description: 'Intensive repair treatment for dry, damaged, or chemically processed hair.', price: 'from 550 AED', duration: '2 hrs' },
  { id: 'n1', category: 'Nails', name: 'Classic Manicure', description: 'Essential nail care, shaping, cuticle work, and regular polish.', price: '100 AED', duration: '1 hr' },
  { id: 'n2', category: 'Nails', name: 'Gel Manicure', description: 'Long-lasting gel polish application with classic manicure for glossy wear.', price: '200 AED', duration: '2 hrs' },
  { id: 'n3', category: 'Nails', name: 'Classic Pedicure', description: 'Essential toe nail care, shaping, cuticle work, and regular polish.', price: '120 AED', duration: '1 hr' },
  { id: 'n4', category: 'Nails', name: 'Nail Extension Refill', description: 'Maintenance refill for acrylic, gel, or builder gel extensions.', price: 'from 210 AED', duration: '1.5 hrs' },
  { id: 'n5', category: 'Nails', name: 'Builder Gel Extensions', description: 'Durable nail extensions designed for elegant length, structure, and finish.', price: 'from 320 AED', duration: '2 hrs' },
  { id: 'n6', category: 'Nails', name: 'Luxury Nail Art', description: 'Custom nail art design for statement manicures, events, and bridal looks.', price: 'from 50 AED', duration: '30 min' },
  { id: 'l1', category: 'Lashes', name: 'Lash Extension (Classic)', description: 'One-to-one lash application for soft, natural-looking definition.', price: '350 AED', duration: '2 hrs' },
  { id: 'l2', category: 'Lashes', name: 'Lash Lift & Tint', description: 'Lift and tint service to create darker, fuller-looking lashes without extensions.', price: '280 AED', duration: '1 hr' },
  { id: 'b1', category: 'Brows', name: 'Brow Lamination', description: 'Restructure brow hairs for a fuller, lifted, and defined look.', price: '250 AED', duration: '1 hr' },
  { id: 'b2', category: 'Brows', name: 'Brow Shaping', description: 'Detailed brow shaping to refine symmetry and frame the face.', price: '80 AED', duration: '30 min' },
  { id: 'f1', category: 'Facials & Skincare', name: 'Classic Facial', description: 'Customized facial to cleanse, exfoliate, and nourish the skin.', price: '400 AED', duration: '1 hr' },
  { id: 'f2', category: 'Facials & Skincare', name: 'HydraFacial', description: 'Advanced resurfacing and hydration treatment for glow, texture, and clarity.', price: '600 AED', duration: '1 hr' },
  { id: 'f3', category: 'Facials & Skincare', name: 'Deep Cleansing Facial', description: 'Clarifying facial designed for congestion, buildup, and city-stressed skin.', price: '450 AED', duration: '1 hr' },
  { id: 'w1', category: 'Wax Services', name: 'Full Face Wax', description: 'Gentle face waxing for smooth skin and a clean makeup-ready finish.', price: '120 AED', duration: '30 min' },
  { id: 'w2', category: 'Wax Services', name: 'Full Body Wax', description: 'Comprehensive body waxing performed with comfort and hygiene in mind.', price: 'from 300 AED', duration: '1.5 hrs' },
  { id: 'a1', category: 'Aesthetics', name: 'Mesotherapy', description: 'Skin revitalizing mesotherapy treatment to support hydration, brightness, and texture.', price: 'from 200 AED', duration: '45 min' },
  { id: 'br1', category: 'Bridal', name: 'Bridal Hair & Makeup', description: 'Bridal beauty service for wedding-day hair, makeup, and finishing touches.', price: 'from 1200 AED', duration: '3 hrs' },
  { id: 'sp1', category: 'Semi Permanent Makeup', name: 'Lip Blush', description: 'Soft pigment infusion for naturally tinted, fuller-looking lips.', price: '1200 AED', duration: '2.5 hrs' },
];
